import axios, { CancelToken } from "axios"
import { InformeTableDataDtoProps } from "./DTOs/InformeTableDataDto"
import { perdidasGananciasByFilterAdapter } from "./PerdidaGanancia.adapter"

interface PerdidaGananciaParams {
  EsMensual?: boolean
  Tipo?: number
  FechaFinMovimiento?: string
  FechaInicioMovimiento?: string
  Keyword?: string
  TipoInforme?: number
  SoloCuentasConSaldo?: boolean
}

export const getPerdidaGanancianByFilters = async (
  queryParams?: PerdidaGananciaParams,
  cancelToken?: CancelToken
): Promise<InformeTableDataDtoProps> => {
  const { data }: { data: InformeTableDataDtoProps } = await axios.get(
    `PerdidaGanancia/by-filters/`,
    { params: queryParams, cancelToken }
  )
  return perdidasGananciasByFilterAdapter(data)
}

export const generatePerdidaGananciaExcel = (
  queryParams?: PerdidaGananciaParams
) => {
  return axios.get(`PerdidaGanancia/generate-excel`, {
    params: queryParams,
    responseType: "blob",
  })
}
